import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-concluir-pedido-estoque-papel',
    templateUrl: './alert-concluir-pedido-estoque-papel.component.html',
    styleUrls: ['./alert-concluir-pedido-estoque-papel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertConcluirPedidoEstoquePapelComponent {

  @Input() alertConcluirPedido: boolean = false;
  @Input() beneficio: string;
  @Input() totalVales: string;
  @Input() outrasCobrancas: string;
  @Input() totalTaxa: string;
  @Input() descontos: string;
  @Input() totalPagar: string;
  @Input() benefitDetails: any;

  @Output() confirmarPedido = new EventEmitter();
  @Output() alertConcluirPedidoFechou = new EventEmitter();

  constructor() { }

  onConfirmarPedido(){
    this.confirmarPedido.emit (true);
  }

  cancelarAlterarEmpresa(){
    this.alertConcluirPedido = false;
    this.alertConcluirPedidoFechou.emit(this.alertConcluirPedido);
  }
}
